
import Vue from "vue";
import store from "@/store";
import LINK from "@/utils/link";
import { convertDate } from "@/utils/date";
import { convertToPersian, separateDigits } from "@/utils/string";
import AppWarning from "@/components/UI/AppWarning.vue";

export default Vue.extend({
  name: "WaitingTab",
  components: {
    AppWarning,
  },
  data() {
    return {
      LINK: LINK,
      imgPrefix: "images/upload-product-images/",
    };
  },
  computed: {
    list() {
      return store.state.panel.invoices.filter(
        (invoice: any) => invoice.status == 0
      );
    },
  },
  methods: {
    convertDate,
    convertToPersian,
    separateDigits,
  },
});
